import Skeleton from "@mui/material/Skeleton";
import { Edit, FileText, MoreVertical } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BackButton } from "src/components/Default/LekUI/BackButton";
import { Menu } from "src/components/Default/LekUI/Menu";
import { useGetUserNote } from "src/hooks/useFolders";
import "src/styles/notes.scss";

interface FolderNotePreviewProps {
	noteId: string;
	onBack: () => void;
	onEdit: () => void;
}

export function FolderNotePreview({
	noteId,
	onBack,
	onEdit,
}: FolderNotePreviewProps) {
	const { t } = useTranslation();
	const { data: noteData, isLoading } = useGetUserNote(noteId);

	if (isLoading) {
		return (
			<div className="content-box border-radius-8 flex flex-col gap-16">
				<Skeleton variant="rounded" width={200} height={28} />
				<div className="border-top-1" />
				<Skeleton variant="rounded" height={200} />
			</div>
		);
	}

	return (
		<div className="content-box border-radius-8 flex flex-col gap-24">
			<div className="w-100 flex flex-col gap-8 pb-16 border-bottom-2">
				<div className="flex items-center justify-between">
					<BackButton onClick={onBack} testId="folder-note-preview-back" />
					<Menu
						icon={<MoreVertical className="icon-small" />}
						buttonTestId="folder-note-preview-menu"
						closeAfterClick
						items={[
							{
								title: t("commands.edit", "Edytuj"),
								onClick: onEdit,
								Icon: <Edit className="icon-small" />,
								testId: "folder-note-preview-edit",
							},
						]}
					/>
				</div>
				<div className="flex items-center gap-8 pr-8">
					<FileText className="icon-small" />
					<h3 className="m-0 size-18 text-ellipsis-1 min-w-0 flex-1">
						{noteData?.name || t("note.untitled", "Notatka bez tytułu")}
					</h3>
				</div>
			</div>
			<div className="tiptap-editor-content">
				<div
					className="tiptap"
					dangerouslySetInnerHTML={{ __html: noteData?.note || "" }}
				/>
			</div>
		</div>
	);
}
